 
 
const baseurl = process.env.BASE_URL || 'https://bosplannew.evventoz.com/api/';   
// const baseurl = process.env.BASE_URL || 'https://backend.techsparesindia.com/api/';  

const imageUrl = process.env.IMAGE_URL || 'https://bosplannew.evventoz.com/uploads/';  
// const imageUrl = process.env.IMAGE_URL || 'https://backend.techsparesindia.com/uploads/';      

module.exports = { baseurl, imageUrl };
